import { useEffect, useState } from "react";
import { Box, Checkbox, Flex, Heading } from "@/ui";
import TrashIcon from "assets/icons/trash.svg?react";
import CloseIcon from "assets/icons/close_large.svg?react";
import { t } from "@/utils";
import { useControls } from "@/hooks";
import { useEventDeletion } from "viewer/store/eventDeletion";
import IconButton from "@/components/IconButton";
import Dialog from "@/components/Dialog";
import ActivityLogController from "../ActivityLogController";

export default function DeletionPanel() {
  const [isAllSelected, setIsAllSelected] = useState(false);
  const deleteDialog = useControls();
  const [isProcessing, setIsProcessing] = useState(false);

  const { addAll, clearSelection, deleteCount, deleteSelectedEvents, toggleDeletionMode } = useEventDeletion((s) => ({
    addAll: s.addAll,
    clearSelection: s.clearSelection,
    deleteCount: s.objectIds.length,
    deleteSelectedEvents: s.deleteSelectedEvents,
    toggleDeletionMode: s.toggleDeletionMode
  }));

  useEffect(() => {
    return ActivityLogController.on("downloaded-next-events", () => {
      setIsAllSelected(false);
    });
  }, []);

  return (
    <Box pt="1rem" px={["1rem", "0.75rem", "1rem"]}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        borderRadius="1rem"
        py="0.5rem"
        px="0.75rem"
        bg="surface"
        h="56"
      >
        <Flex alignItems="center" gap="16">
          <Checkbox
            isChecked={isAllSelected}
            onChange={({ target: { checked } }) => {
              checked ? addAll() : clearSelection();
              setIsAllSelected(checked);
            }}
          >
            {t("selectAll")}
          </Checkbox>

          <Heading as="h5">
            {deleteCount === 0 ? t("selectItems") : t("plurals:num.item", { count: deleteCount })}
          </Heading>
        </Flex>

        <Flex alignItems="center" gap="2">
          <IconButton
            icon={TrashIcon}
            fill="on-surface"
            onClick={deleteDialog.open}
            p="4"
            props={{
              opacity: deleteCount > 0 ? 1 : 0
            }}
          />
          <IconButton icon={CloseIcon} fill="on-surface" onClick={toggleDeletionMode} iconSize="16" />
        </Flex>
      </Flex>
      <Dialog
        isProcessing={isProcessing}
        onClose={deleteDialog.close}
        isOpen={deleteDialog.isOpen}
        onConfirm={async () => {
          setIsProcessing(true);
          await deleteSelectedEvents();
          deleteDialog.close();
          setIsProcessing(false);
        }}
        iconProps={{ fill: "error" }}
        icon={TrashIcon}
        title={t("deleteEvents.title")}
        body={t("deleteEvents.description")}
        buttons={{
          cancel: { label: t("buttons.cancel") },
          confirm: { label: t("buttons.delete"), color: "error" }
        }}
      />
    </Box>
  );
}
